const initialState = {
  searchText: '',
  pageNumber: 1,
  totalSize: 0
};
const resetState = {
  searchText: '',
  pageNumber: 1,
  totalSize: 0
};

const moduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SETMODULEPAGENUMBER':
      return {
        ...state,
        pageNumber: action.payload,
      };
    case 'SETMODULETOTALSIZE':
      return {
        ...state,
        totalSize: action.payload,
      };
    case 'SETMODULESEARCHTEXT':
      return {
        ...state,
        searchText: action.payload,
      };
    case 'SETMODULERESET':
      return {
        ...state,
        ...resetState,
      };

    default:
      return state;
  }
};

export default moduleReducer;